export const PAYMENTS_POPUP = {
    AMOUNT_TO_PAY: "amount-to-pay",
    MODAL: "payments-modal",
    METHOD_SAVED_SUCCESS_MODAL: "payment-method-saved-success-modal",
};

export const CARD_DETAILS = {
    CONTAINER: "card-details-container",
    TITLE: "card-details-title",
    CARD_ICON: "card-details-icon",
    CARD_NUMBER: "card-details-number",
    NICKNAME: "card-details-nickname",
    OWNER: "card-details-owner",
    EMAIL: "card-details-email",
    EXP: "card-details-exp",
    ADDED_BY: "card-details-added-by",
    ADDED_ON: "card-details-added-on",
    CLICK_HERE_TO_MANAGE: "card-details-click-here-to-manage",
};

export const PAYMENTS_PREFERENCES = {
    UPDATE_PREFERENCES_BTN: "update-preferences-btn",
    PAYMENT_PREFERENCES_SETTINGS: "payment-preferences-settings",
};

export const PAYMENT_METHODS = {
    SECTION: "payment-methods-section",
    HEADER: "payment-methods-header",
    LIST_CONTAINER: "payment-methods-container",
    CREDIT_CARD_TAB: "credit-card-tab",
    ACH_TAB: "ach-tab",
    PAYMENT_METHOD_ITEM_CONTAINER: "payment-method-item-container",
    PAYMENT_METHOD_SELECT_RADIO: "payment-method-select-radio",
    CREDIT_CARD_EXPIRED_TEXT: "credit-card-expired-text",
    CREDIT_CARD_DETAILS_CONTAINER: "credit-card-details-container",
    ADD_PAYMENT_METHOD_BUTTON: "add-payment-method-button",
    ADD_CREDIT_CARD_MODAL: "add-credit-card-modal",
    ACCEPTED_CREDIT_CARDS: "accepted-credit-cards",
    CREDIT_CARD_DETAILS: "credit-card-detail",
    ACH_DETAILS: "ach-details",
};

export const PAYMENT_OPTIONS = {
    PAYMENT_OPTIONS_CONTAINER: "payment-options-container",
    SAVE_PAYMENT_ACTION: "save-payment-action",
    CAN_ENTER_PAYMENT_ACTION: "can-enter-payment-action",
    SKIP_PAYMENT_ACTION: "skip-payment-action",
};
